import { isSalesStaff } from '../../auth/roles';
import { createRoleRoute } from './createRoleRoute';

/**
 * Pathless layout under /admin for the Relations CRM: AdminRoute already
 * admitted a STAFF user; this admits SALES_STAFF (account_sales + admins)
 * and gives everyone else — account_retoucher included — Forbidden, deep
 * links included. relations-service gates the same set (Roles::SALES_STAFF),
 * so without this guard a retoucher would get the Relations shell and a
 * backend 403 inside it instead of a clear Forbidden page.
 *
 * The `relations` account feature flag is a separate question, answered one
 * level down by RelationsGate.
 */
const SalesStaffRoute = createRoleRoute('SalesStaffRoute', isSalesStaff, 'sales_staff');

export default SalesStaffRoute;
